import { Inject, Injectable, isDevMode } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable, firstValueFrom } from 'rxjs';
import { OktaApp } from '../objects/oktaObj';
import { OidcToken } from '../objects/oidcToken';
import { environment } from '../environments/environment';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { Country } from '../app/shared/country.model';

@Injectable({
  providedIn: 'root',
})
export class SupportService {
  constructor(
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    private http: HttpClient
  ) {}

  static apiDomain = environment.apiDomain;
  static iamsmartDomain = environment.iamsmartDomain;

  async getIamsmartProfile(iamsmartOpenId: string): Promise<any> {
    var postParam: HttpParams = new HttpParams();
    postParam = postParam.append('openid', iamsmartOpenId);

    return firstValueFrom(
      this.http.post(
        SupportService.iamsmartDomain + 'api/profileByOpenId',
        postParam,
        {
          headers: new HttpHeaders({}),
        }
      )
    );
  }

  // TODO: add verification token for each factor
  async register(obj: {
    personalTitle: string;
    firstName: string;
    lastName: string;
    firstNameZh: string;
    lastNameZh: string;
    email: string;
    emailVerifyToken: string;
    mobilePhone: string;
    mobileVerifyToken: string;
    password: string;
    companyName: string;
    companyInd: string;
    jobTitle: string;
    noCompanyInfo: boolean;
    isFactorForceActivated?: boolean;
    deviceToken: string;
    iamSmartOpenId?: string;
  }): Promise<any> {
    var postParam: HttpParams = new HttpParams();
    postParam = postParam.append('title', obj.personalTitle);
    postParam = postParam.append('firstName', obj.firstName);
    postParam = postParam.append('lastName', obj.lastName);
    if (obj.firstNameZh != '')
      postParam = postParam.append('firstNameZh', obj.firstNameZh);
    if (obj.lastNameZh != '')
      postParam = postParam.append('lastNameZh', obj.lastNameZh);
    if (obj.email != '') postParam = postParam.append('email', obj.email);
    if (obj.emailVerifyToken != '')
      postParam = postParam.append('emailVerifyToken', obj.emailVerifyToken);
    if (obj.mobilePhone != '')
      postParam = postParam.append('mobile', obj.mobilePhone);
    if (obj.mobileVerifyToken != '')
      postParam = postParam.append('mobileVerifyToken', obj.mobileVerifyToken);
    postParam = postParam.append('password', obj.password);
    if (obj.companyName != '')
      postParam = postParam.append('companyName', obj.companyName);
    if (obj.companyInd != '')
      postParam = postParam.append('companyInd', obj.companyName);
    if (obj.jobTitle != '')
      postParam = postParam.append('jobTitle', obj.jobTitle);
    if (obj.jobTitle != '')
      postParam = postParam.append('jobTitle', obj.jobTitle);
    if (obj.iamSmartOpenId)
      postParam = postParam.append('iamSmartOpenId', obj.iamSmartOpenId);

    postParam = postParam.append('noCompanyInfo', obj.noCompanyInfo);
    postParam = postParam.append(
      'isFactorForceActivated',
      obj.isFactorForceActivated ?? false
    );

    return firstValueFrom(
      this.http.post(SupportService.apiDomain + 'User/Register', postParam, {
        headers: new HttpHeaders({}),
      })
    );
  }

  // async verify2FaSms(code: string, phoneNumber: string): Promise<any> {
  //   var postParam: HttpParams = new HttpParams();
  //   // postParam = postParam.append("userId", userId);
  //   postParam = postParam.append('passCode', code);
  //   postParam = postParam.append('phoneNumber', phoneNumber);
  //   return firstValueFrom(
  //     this.http.post(
  //       SupportService.apiDomain + 'Factor/Submit2faSms',
  //       postParam,
  //       {
  //         headers: new HttpHeaders({}),
  //       }
  //     )
  //   );
  // }

  // async verifyOkta2FaSms(userId: string, code: string): Promise<any> {
  //   var postParam: HttpParams = new HttpParams();
  //   postParam = postParam.append("userId", userId);
  //   postParam = postParam.append('passCode', code);
  //   return firstValueFrom(
  //     this.http.post(
  //       SupportService.apiDomain + 'Factor/SubmitOkta2faSms',
  //       postParam,
  //       {
  //         headers: new HttpHeaders({}),
  //       }
  //     )
  //   );
  // }

  // async enable2FaEmail(
  //   active: boolean,
  //   locale?: string,
  //   email?: string | null,
  //   englishName?: string | null,
  //   chineseName?: string | null,
  //   isOkta: boolean = false,
  //   userId?: string | null
  // ): Promise<any> {
  //   var postParam: HttpParams = new HttpParams();
  //   var headers: HttpHeaders = new HttpHeaders();

  //   if(isOkta && userId) {
  //     postParam = postParam.append("userId", userId);
  //   }

  //   postParam = postParam.append('active', active);
  //   if (email) {
  //     postParam = postParam.append('email', email);
  //   }
  //   if (locale) {
  //     postParam = postParam.append('locale', locale);
  //   }
  //   if (englishName) {
  //     postParam = postParam.append('english_name', englishName);
  //   }
  //   if (chineseName) {
  //     postParam = postParam.append('chinese_name', chineseName);
  //   }
  //   return firstValueFrom(
  //     this.http.post(
  //       SupportService.apiDomain + (userId ? 'Factor/' : 'Factor/auth/') + (isOkta ? 'EnableOkta2faEmail' : 'Enable2faEmail'),
  //       postParam,
  //       {
  //         headers: new HttpHeaders({}),
  //       }
  //     )
  //   );
  // }

  // async send2FaSms(
  //   phoneNumber?: string | null,
  //   englishName?: string | null,
  //   chineseName?: string | null,
  //   workerId?: string | null
  // ): Promise<ApiResponse<Object>> {
  //   return firstValueFrom(
  //     this.http.post(
  //       SupportService.apiDomain + 'Factor/SendSms2faVerifyId',
  //       {
  //         phone_number: phoneNumber,
  //         english_name: englishName,
  //         chinese_name: chineseName,
  //         worker_id: workerId,
  //       },
  //       {
  //         headers: new HttpHeaders({}),
  //       }
  //     )
  //   ) as Promise<ApiResponse<any>>;
  // }

  // async send2FaEmail(
  //   email?: string | null,
  //   englishName?: string | null,
  //   chineseName?: string | null,
  //   workerId?: string | null
  // ): Promise<ApiResponse<Object>> {
  //   return firstValueFrom(
  //     this.http.post(
  //       SupportService.apiDomain + 'Factor/SendEmail2faVerifyId',
  //       {
  //         email: email,
  //         english_name: englishName,
  //         chinese_name: chineseName,
  //         worker_id: workerId,
  //       },
  //       {
  //         headers: new HttpHeaders({}),
  //       }
  //     )
  //   ) as Promise<ApiResponse<any>>;
  // }

  // async verify2FaEmail(code: string, email: string, isOkta: boolean = false, userId?: string | null): Promise<any> {
  //   var postParam: HttpParams = new HttpParams();
  //   postParam = postParam.append('passCode', code);
  //   postParam = postParam.append('email', email);
  //   if(isOkta && userId) {
  //     postParam = postParam.append("userId", userId);
  //   }
  //   return firstValueFrom(
  //     this.http.post(
  //       SupportService.apiDomain + (userId ? 'Factor/' : 'Factor/auth/') + (isOkta ? 'SubmitOkta2faEmail' : 'Submit2faEmail'),
  //       postParam,
  //       {
  //         headers: new HttpHeaders({}),
  //       }
  //     )
  //   );
  // }

  async updateUserProfile(profile: any): Promise<any> {
    const accessToken = this.oktaAuth.getAccessToken();
    var postParam: HttpParams = new HttpParams();
    // postParam = postParam.append("userId", userId);
    postParam = postParam.appendAll(profile);
    return firstValueFrom(
      this.http.post(
        SupportService.apiDomain + 'User/AuthUpdateUserProfile',
        postParam,
        {
          headers: new HttpHeaders({}),
        }
      )
    );
  }

  async getLoginAppConfig(app?: string, appid?: string): Promise<any> {
    var getParam: HttpParams = new HttpParams();
    if(app) getParam = getParam.append('app', app);
    if(appid) getParam = getParam.append('appid', appid);
    return firstValueFrom(
      this.http.get(SupportService.apiDomain + 'User/GetLoginAppConfig', {
        params: getParam,
        headers: new HttpHeaders({}),
      })
    );
  }

  async get2faStatus(account?: string, userId?: string): Promise<any> {
    var getParam: HttpParams = new HttpParams();
    if (account) {
      getParam = getParam.append('account', account);
    }
    if (userId) {
      getParam = getParam.append('userId', userId);
    }

    let factorList = await firstValueFrom(
      this.http.get<Array<any>>(
        SupportService.apiDomain + (account || userId ? 'Factor/Get2faStatus' : 'Factor/auth/Get2faStatus'),
        {
          params: getParam,
          headers: new HttpHeaders({}),
        }
      )
    );

    let recoveryToken = factorList.find((fa) =>
      Boolean(fa?.recoveryToken)
    )?.recoveryToken;

    if (recoveryToken) {
      sessionStorage.setItem('recovery_token', recoveryToken);
    }

    return factorList;
  }

  async getIamSmartStatus(): Promise<any> {
    var getParam: HttpParams = new HttpParams();

    let factorList = await firstValueFrom(
      this.http.get<Array<any>>(
        SupportService.apiDomain + 'Factor/auth/GetIamSamrtStatus',
        {
          params: getParam,
          headers: new HttpHeaders({}),
        }
      )
    );

    return factorList;
  }

  async unbindIamSmart(): Promise<any> {
    var postParam: HttpParams = new HttpParams();

    let factorList = await firstValueFrom(
      this.http.post<Array<any>>(
        SupportService.apiDomain + 'Factor/auth/UnbindIamSmart',
        postParam,
        {
          headers: new HttpHeaders({}),
        }
      )
    );

    return factorList;
  }

  // async removeEmail2fa(): Promise<any> {
  //   var postParam: HttpParams = new HttpParams();
  //   // postParam = postParam.append('userId', userId);
  //   return firstValueFrom(
  //     this.http.post(
  //       SupportService.apiDomain + 'Factor/auth/Remove2faEmail',
  //       postParam,
  //       {
  //         headers: new HttpHeaders({}),
  //       }
  //     )
  //   );
  // }

  // async removeSms2fa(): Promise<any> {
  //   var postParam: HttpParams = new HttpParams();
  //   // postParam = postParam.append('userId', userId);
  //   return firstValueFrom(
  //     this.http.post(
  //       SupportService.apiDomain + 'Factor/auth/Remove2faSms',
  //       postParam,
  //       {
  //         headers: new HttpHeaders({}),
  //       }
  //     )
  //   );
  // }

  async getAppListByUser(): Promise<OktaApp[]> {
    const accessToken = this.oktaAuth.getAccessToken();
    var getParam: HttpParams = new HttpParams();
    // getParam = getParam.append("userId", userId);
    return firstValueFrom(
      this.http.get(SupportService.apiDomain + 'User/GetAppsByUserId', {
        params: getParam,
        headers: new HttpHeaders({}),
      })
    ).then((r) => {
      let rr = r as [];
      if (rr.length > 0) {
        return rr.map((item: any) => {
          item.item2.id = item.item1;
          return item.item2;
        });
      }
      return [];
    }) as Promise<OktaApp[]>;
  }

  async getHistoryByUser(): Promise<any> {
    const accessToken = this.oktaAuth.getAccessToken();
    var getParam: HttpParams = new HttpParams();
    // getParam = getParam.append("userId", userId);
    return firstValueFrom(
      this.http.get(SupportService.apiDomain + 'User/GetHistoryByUserId', {
        params: getParam,
        headers: new HttpHeaders({}),
      })
    ) as Promise<OktaApp[]>;
  }

  async changePassword(oldPassword: string, newPassword: string): Promise<any> {
    const accessToken = this.oktaAuth.getAccessToken();
    var postParam: HttpParams = new HttpParams();
    // postParam = postParam.append("userId", userId);
    postParam = postParam.append('oldPassword', oldPassword);
    postParam = postParam.append('newPassword', newPassword);
    return firstValueFrom(
      this.http.post(
        SupportService.apiDomain + 'User/ChangePasswordByUserId',
        postParam,
        {
          headers: new HttpHeaders({}),
        }
      )
    );
  }

  // async lookupUserByEmail(email: string): Promise<string | boolean> {
  //   var getParam: HttpParams = new HttpParams();
  //   getParam = getParam.append('email', email);
  //   return firstValueFrom(
  //     this.http.get(SupportService.apiDomain + 'Lookup/SearchUserByEmail', {
  //       params: getParam,
  //       headers: new HttpHeaders({}),
  //     })
  //   ) as Promise<string | boolean>;
  // }

  // async lookupUserByPhone(phone: string): Promise<string | boolean> {
  //   var getParam: HttpParams = new HttpParams();
  //   getParam = getParam.append('phone', phone);
  //   return firstValueFrom(
  //     this.http.get(SupportService.apiDomain + 'Lookup/SearchUserByPhone', {
  //       params: getParam,
  //       headers: new HttpHeaders({}),
  //     })
  //   ) as Promise<string | boolean>;
  // }

  async lookupUser(
    username: string,
    usernameTypes: string[] = ['email', 'phone number']
  ): Promise<any | boolean> {
    var getParam: HttpParams = new HttpParams();
    getParam = getParam.append('username', username);
    getParam = getParam.append('types', usernameTypes.join(','));
    return firstValueFrom(
      this.http.get(SupportService.apiDomain + 'Lookup/SearchUserExists', {
        params: getParam,
        headers: new HttpHeaders({}),
      })
    ) as Promise<any | boolean>;
  }

  async getForgetPasswordLink(): Promise<string | boolean> {
    var getParam: HttpParams = new HttpParams();
    // getParam = getParam.append('userId', userId);
    return firstValueFrom(
      this.http.get(SupportService.apiDomain + 'User/GetResetPasswordLink', {
        params: getParam,
        headers: new HttpHeaders({}),
      })
    ) as Promise<string | boolean>;
  }

  // TODO: WTF is this?
  async resetPassword(
    account: string,
    // firstName: string,
    // lastName: string,
    password: string,
    token: string
  ): Promise<any> {
    var postParam: HttpParams = new HttpParams();
    // postParam = postParam.append("userId", userId);
    // postParam = postParam.append('first_name', firstName);
    // postParam = postParam.append('last_name', lastName);
    // postParam = postParam.append('password', password);

    return firstValueFrom(
      this.http.post(
        SupportService.apiDomain + 'User/ResetPassword',
        {
          account: account,
          // first_name: firstName,
          // last_name: lastName,
          password: password,
          token: token
        },
        {
          headers: new HttpHeaders({}),
        }
      )
    );
  }

  async createTokenRecord(
    sessiontoken: string,
    state: string,
    redirecturi: string
  ): Promise<OidcToken> {
    var postParam: HttpParams = new HttpParams();
    postParam = postParam.append('sessiontoken', sessiontoken);
    postParam = postParam.append('state', state);
    postParam = postParam.append('redirecturi', redirecturi);
    return firstValueFrom(
      this.http.post(
        SupportService.apiDomain + 'Oidc/CreateTokenRecord',
        postParam,
        {
          headers: new HttpHeaders({}),
        }
      )
    ) as Promise<OidcToken>;
  }

  async updateTokenRecord(
    state: string,
    accesstoken: string,
    expiresin: number,
    scope: string
  ): Promise<OidcToken> {
    var postParam: HttpParams = new HttpParams();
    postParam = postParam.append('state', state);
    postParam = postParam.append('accesstoken', accesstoken);
    postParam = postParam.append('expiresin', expiresin);
    postParam = postParam.append('scope', scope);
    return firstValueFrom(
      this.http.post(
        SupportService.apiDomain + 'Oidc/UpdateTokenRecord',
        postParam,
        {
          headers: new HttpHeaders({}),
        }
      )
    ) as Promise<OidcToken>;
  }

  async getTokenRecord(state: string): Promise<OidcToken | boolean> {
    var getParam: HttpParams = new HttpParams();
    getParam = getParam.append('state', state);
    return firstValueFrom(
      this.http.get(SupportService.apiDomain + 'User/GetTokenRecord', {
        params: getParam,
        headers: new HttpHeaders({}),
      })
    ) as Promise<OidcToken | boolean>;
  }

  async getTokenDataByVerificationToken(
    token: string
  ): Promise<ApiResponse<any>> {
    var getParam: HttpParams = new HttpParams();
    getParam = getParam.append('token', token);
    return firstValueFrom(
      this.http.get(SupportService.apiDomain + 'User/GetVerifyDataByToken', {
        params: getParam,
        headers: new HttpHeaders({}),
      })
    ) as Promise<ApiResponse<any>>;
  }

  getVerifyCallbackUrl(token: string): string {
    return SupportService.apiDomain + 'User/VerifyCallback?token=' + token;
  }

  // TODO: no use after using Okta login
  async assignUserGroupByApp(appName: string): Promise<ApiResponse<any>> {
    var postParam: HttpParams = new HttpParams();
    // postParam = postParam.append("userId", userId);
    postParam = postParam.append('appName', appName);
    return firstValueFrom(
      this.http.post(
        SupportService.apiDomain + 'User/assignUserGroupByApp',
        postParam,
        {
          headers: new HttpHeaders({}),
        }
      )
    ) as Promise<ApiResponse<any>>;
  }

  // TODO: no use after using Okta login
  async assignUserGroup(groupId: string): Promise<ApiResponse<any>> {
    var postParam: HttpParams = new HttpParams();
    // postParam = postParam.append("userId", userId);
    postParam = postParam.append('groupId', groupId);
    return firstValueFrom(
      this.http.post(
        SupportService.apiDomain + 'User/AssignUserGroup',
        postParam,
        {
          headers: new HttpHeaders({}),
        }
      )
    ) as Promise<ApiResponse<any>>;
  }

  async getCountries(): Promise<Country[]> {
    const _countries = [
      {
        idd: '+852',
        name: 'Hong Kong, China',
        isoAlpha2: 'HK',
        mask: undefined,
      },
      {
        idd: '+86',
        name: 'China',
        isoAlpha2: 'CN',
        mask: undefined,
      },
      {
        idd: '+853',
        name: 'Macau, China',
        isoAlpha2: 'MO',
        mask: undefined,
      },
    ];

    if (isDevMode()) {
      _countries.push({
        idd: '+60',
        name: 'Malaysia',
        isoAlpha2: 'MY',
        mask: undefined,
      });
    }

    return _countries;
  }

  async forgotUsername(
    workerId?: string | null,
    supplierId?: string | null,
    recaptchaV2Token?: string,
    recaptchaV3Token?: string
  ): Promise<
    ApiResponse<{
      email?: string | null;
      mobilePhone?: string | null;
      workerId?: string | null;
      supplierId?: string | null;
    }>
  > {
    var postParam: HttpParams = new HttpParams();
    if (!!workerId) {
      postParam = postParam.append('workerId', workerId);
    }
    if (!!supplierId) {
      postParam = postParam.append('supplierId', supplierId);
    }
    postParam = postParam.append('recaptchaV2Token', recaptchaV2Token ?? '');
    postParam = postParam.append('recaptchaV3Token', recaptchaV3Token ?? '');
    return firstValueFrom(
      this.http.post(
        SupportService.apiDomain + 'User/ForgotUsername',
        postParam,
        {
          headers: new HttpHeaders({}),
        }
      )
    ) as Promise<ApiResponse<any>>;
  }

  async sendUsername(
    deliveryMethod: 'email' | 'sms',
    workerId?: string | null,
    supplierId?: string | null
  ): Promise<ApiResponse<any>> {
    var body: Record<string, any> = {};
    if (!!workerId) {
      body['worker_id'] = workerId;
    }
    if (!!supplierId) {
      body['supplier_id'] = supplierId;
    }

    const response = (await firstValueFrom(
      // this.http.get(SupportService.apiDomain + 'User/ForgotUsername/', {
      this.http.post(
        `${SupportService.apiDomain}User/ForgotUsername/${deliveryMethod}`,
        body
      )
    )) as ApiResponse<{
      email?: string | null;
      mobilePhone?: string | null;
      workerId?: string | null;
      supplierId?: string | null;
    }>;

    return response;
  }

  async recaptchaV3Validate(token: string): Promise<ApiResponse<any>> {
    var postParam: HttpParams = new HttpParams();
    // postParam = postParam.append("userId", userId);
    postParam = postParam.append('token', token);
    return firstValueFrom(
      this.http.post(
        SupportService.apiDomain + 'User/RecaptchaV3Validate',
        postParam,
        {
          headers: new HttpHeaders({}),
        }
      )
    ) as Promise<ApiResponse<any>>;
  }
}

export interface ApiResponse<T> {
  success: boolean;
  errorMessage: string;
  value: T;
}
